/**
 * Formats CMS page content for better readability.
 * If the content is already HTML (contains tags), it's returned as-is.
 * If it's plain text, double newlines become paragraph breaks.
 */
export function formatPageContent(raw) {
  if (!raw || typeof raw !== 'string') return '';

  const trimmed = raw.trim();

  // If content already has block-level HTML tags, return as-is
  if (/<(p|div|h[1-6]|ul|ol|table|section|article)\b/i.test(trimmed)) {
    return trimmed;
  }

  // Plain text — wrap double-newline-separated blocks in <p> tags
  return trimmed
    .split(/\n\s*\n/)
    .map(block => `<p>${block.replace(/\n/g, '<br />')}</p>`)
    .join('\n');
}
